'use client';
import { useTranslation } from '@/i18n/client';

import UKDialog from '@/components/UKDialog';
import { Button, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import Styles from './index.module.scss';

interface PayCommonErrorModalProps {
  isShowTitle?: boolean;
  title?: string;
  content: string;
  open: boolean;
  handleClose?: () => void;
  handleOk: () => void;
}
/**
 *
 * 结算支付通用错误处理弹窗
 *
 */
const PayCommonErrorModal = ({
  handleClose,
  handleOk,
  open,
  isShowTitle = true,
  title,
  content,
}: PayCommonErrorModalProps) => {
  const { t } = useTranslation();

  // 点击叉关闭
  const onClose = () => {
    handleClose ? handleClose() : handleOk();
  };

  return (
    <UKDialog open={open} onClose={onClose} showCloseBtn={true}>
      <DialogTitle>{isShowTitle && (title || t('checkout.common.paymentFailed'))}</DialogTitle>

      {/* Error info */}
      <DialogContent className={Styles.payError}>
        {content || t('common.message.networkError')}
      </DialogContent>

      {/* Button */}
      <DialogActions>
        <Button onClick={handleOk} variant='contained' size='small' sx={{ boxShadow: 'none' }}>
          {' '}
          {t('checkout.common.continue')}
        </Button>
      </DialogActions>
    </UKDialog>
  );
};

export default PayCommonErrorModal;
